(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["landing-page-ugc"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lp-testimonial-carousel')) {
    customElements.define('lp-testimonial-carousel', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const track = this.querySelector('.lp-testimonials__track');
        const position = this.querySelector('.lp-testimonials__position');
        if (!track || !position) return;
        const total = track.children.length;
        this.querySelectorAll('[data-direction]').forEach(button => {
          button.addEventListener('click', () => {
            const current = Math.round(track.scrollLeft / track.clientWidth);
            const next = (current + Number(button.dataset.direction) + total) % total;
            track.scrollTo({ left: next * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          }, options);
        });
        track.addEventListener('scroll', () => {
          const current = Math.min(total, Math.round(track.scrollLeft / track.clientWidth) + 1);
          position.textContent = current + ' / ' + total;
        }, { ...options, passive: true });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-lymphoria-hero"] && !Shopify.designMode) return;
  try {
    
  /**
   * Apply a bundle selection (1x / 3x) and sync ATC / form fields from its
   * data attributes. Used after flavour/format swaps so the retained bundle
   * is correct before the new section is painted.
   * @param {Element} section
   * @param {string} bundleValue
   */
  function rdlApplyBundleSelection(section, bundleValue) {
    if (!section || !bundleValue) return;
    var target = section.querySelector('.rdl-bundle__input[value="' + bundleValue + '"]');
    if (!target) return;

    section.querySelectorAll('.rdl-bundle__input').forEach(function (input) {
      input.checked = input === target;
    });

    var priceEl = section.querySelector('[data-rdl-atc-price]');
    var wasEl = section.querySelector('[data-rdl-atc-was]');
    var idInput = section.querySelector('[data-rdl-variant-input]');
    var spInput = section.querySelector('[data-rdl-selling-plan-input]');
    var refillsEl = section.querySelector('[data-rdl-refills-label]');
    var altEl = section.querySelector('[data-rdl-altperk]');

    if (priceEl && target.dataset.priceNow) priceEl.innerHTML = target.dataset.priceNow;
    if (wasEl && target.dataset.priceWas) wasEl.innerHTML = target.dataset.priceWas;
    if (idInput && target.dataset.variantId) idInput.value = target.dataset.variantId;
    if (spInput) spInput.value = target.dataset.sellingPlan || '';
    if (refillsEl && target.dataset.refills) refillsEl.textContent = target.dataset.refills;
    if (altEl) {
      if (target.dataset.altPrice) {
        altEl.removeAttribute('hidden');
      } else {
        altEl.setAttribute('hidden', '');
      }
    }

    // Swap the active gallery + thumb images to the selected bundle pack shot.
    if (target.dataset.image) {
      var mainImg =
        section.querySelector('.main_slider .swiper-slide-active img') ||
        section.querySelector('.main_slider .swiper-slide img');
      if (mainImg) {
        mainImg.src = target.dataset.image;
        if (target.dataset.srcset) {
          mainImg.srcset = target.dataset.srcset;
        } else {
          mainImg.removeAttribute('srcset');
        }
      }

      var thumbImg =
        section.querySelector('.thumbs_slider .swiper-slide-thumb-active img') ||
        section.querySelector('.thumbs_slider .swiper-slide img');
      if (thumbImg) {
        thumbImg.src = target.dataset.image;
      }
    }
  }

  // Bundle radio → ATC price/variant swap (event delegation, survives section AJAX swap).
  document.addEventListener('change', function (e) {
    if (!e.target || e.target.name !== 'rdl-bundle' || !e.target.checked) return;
    var section = e.target.closest('[data-rdl-section]') || document;
    rdlApplyBundleSelection(section, e.target.value);
  });

  // Free-gift-with-subscription helpers (mirrors snippets/flavour-bundle.liquid).
  function rdlNormalizeVariantId(variantId) {
    if (typeof variantId !== 'string') return variantId;
    if (variantId.indexOf('gid://shopify/ProductVariant/') !== -1) {
      return variantId.split('/').pop();
    }
    return variantId;
  }

  function rdlBuildParentWithGiftLines(parentLine, giftLines) {
    var gifts = Array.isArray(giftLines) ? giftLines : [];
    if (gifts.length === 0) return [parentLine];
    return gifts.slice().reverse().concat(parentLine);
  }

  /**
   * Shared cart-add helper — POST to /cart/add.js, fetch cart, dispatch events.
   * @param {Array}        items   - Array of line item objects for /cart/add.js
   * @param {Element|null} button  - ATC button (toggled is-loading/disabled)
   * @param {Element|null} errorEl - Element to show error messages
   */
  function rdlDoCartAdd(items, button, errorEl) {
    if (button) {
      button.disabled = true;
      button.classList.add('is-loading');
    }
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (data) {
            throw new Error(data.description || 'Could not add to cart');
          });
        }
        return res.json();
      })
      .then(function () {
        return fetch('/cart.js', { credentials: 'include' }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:changed', { bubbles: true, detail: { cart: cart, cartData: cart } }));
        document.dispatchEvent(new CustomEvent('cart:item-added', { bubbles: true, detail: { cart: cart, cartData: cart } }));
        setTimeout(function () {
          var drawerBtn = document.querySelector('[data-action="show-cart-drawer"]');
          if (drawerBtn) drawerBtn.click();
        }, 600);
      })
      .catch(function (err) {
        console.error('rdl-hero ATC:', err);
        if (errorEl) {
          errorEl.textContent = err.message || 'Sorry, something went wrong. Please try again.';
          errorEl.removeAttribute('hidden');
        }
      })
      .finally(function () {
        if (button) {
          button.disabled = false;
          button.classList.remove('is-loading');
        }
      });
  }

  // Add to Cart — AJAX submit (matches site-wide cart drawer pattern) instead of
  // the default form POST, which would redirect to /cart.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.rdl-form');
    if (!form) return;
    e.preventDefault();

    var section = form.closest('[data-rdl-section]') || document;
    var idInput = form.querySelector('[data-rdl-variant-input]');
    var spInput = form.querySelector('[data-rdl-selling-plan-input]');
    var button = form.querySelector('.rdl-atc');
    var errorEl = form.querySelector('[data-rdl-atc-error]');

    if (errorEl) {
      errorEl.textContent = '';
      errorEl.setAttribute('hidden', '');
    }

    // ── Build-mode branch (Variant B/C active + 3x bundle selected) ──
    if (typeof rdlIsBuildMode === 'function' && rdlIsBuildMode(section)) {
      var total = typeof rdlBundleTotal === 'function' ? rdlBundleTotal() : 0;
      if (total !== 3) return;

      var activeEntries = Object.keys(rdlBundleState).filter(function (k) {
        return rdlBundleState[k] > 0;
      }).map(function (k) {
        return { flavour: k, qty: rdlBundleState[k] };
      });

      var isMixed = activeEntries.length > 1;

      // Same-flavour × 3 that matches the server-rendered var_3x → use normal path
      var checked3x = section.querySelector('.rdl-bundle__input[value="3x"]');
      var serverFlavour = checked3x ? checked3x.getAttribute('data-bundle-flavour') : null;
      var useSameFlavourPath = !isMixed
        && activeEntries.length === 1
        && activeEntries[0].flavour === serverFlavour;

      if (!useSameFlavourPath) {
        // Mixed flavours (or same-flavour different from server-rendered):
        // one Skio Static Box parent line, with _pvgid flavour quantities
        // so Skio creates $0 child lines at order time.
        var config = window.rdlBundleConfig || {};
        var staticBoxVariantId = parseInt(config.staticBoxVariantId, 10) || 0;
        var staticBoxSellingPlanId = parseInt(config.staticBoxSellingPlanId, 10) || 0;

        if (!staticBoxVariantId) {
          console.warn('[RDL Bundle] Static box variant ID is not configured.');
          if (errorEl) {
            errorEl.textContent = 'Mixed bundles will be available very soon — select 3 of the same flavour to add today.';
            errorEl.removeAttribute('hidden');
          }
          return;
        }

        if (button) {
          button.disabled = true;
          button.classList.add('is-loading');
        }

        rdlEnsureStaticBox().then(function () {
          var properties = {};
          var bundleParts = [];
          var missingFlavour = null;
          var boxGroupId =
            Date.now() + '-' + Math.random().toString(16).slice(2);

          activeEntries.forEach(function (entry) {
            var tile = section.querySelector(
              '[data-rdl-build-tile][data-flavour="' + entry.flavour + '"]'
            );
            var flavourName = tile
              ? (tile.getAttribute('data-flavour-name') || '').trim()
              : '';
            var boxVarId = rdlFindBoxVariantId(flavourName);
            if (!boxVarId) {
              missingFlavour = flavourName || entry.flavour;
              return;
            }
            // The _pvgid properties are the Skio Static Box contract: Skio reads
            // them at order time and adds each flavour as a $0 child line itself.
            // Never add those same flavours as cart lines here as well — they
            // would land on the order twice.
            properties['_pvgid://shopify/ProductVariant/' + boxVarId] = entry.qty;
            bundleParts.push(entry.qty + 'x ' + (flavourName || entry.flavour));
          });

          if (missingFlavour) {
            throw new Error(
              missingFlavour +
                ' is not available in this mixed bundle. Please choose a different flavour.'
            );
          }

          var firstTile = section.querySelector(
            '[data-rdl-build-tile][data-flavour="' +
              activeEntries[0].flavour +
              '"]'
          );
          var giftLookupId = firstTile
            ? parseInt(firstTile.getAttribute('data-gift-variant-id'), 10)
            : 0;

          var giftMap =
            window.ThatWorks &&
            window.ThatWorks.freeGiftsWithSubscriptionOfVariants
              ? window.ThatWorks.freeGiftsWithSubscriptionOfVariants
              : null;
          var fgMixed = giftMap ? giftMap[staticBoxVariantId] : null;
          if (
            (!Array.isArray(fgMixed) || fgMixed.length === 0) &&
            giftMap &&
            giftLookupId
          ) {
            fgMixed = giftMap[giftLookupId];
          }
          var hasFgMixed = Array.isArray(fgMixed) && fgMixed.length > 0;

          var parentProperties = Object.assign({}, properties);
          parentProperties._box_group_id = boxGroupId;
          // Human-readable box contents. Drives the flavour rows in the cart
          // drawer (cart-item.liquid `Bundle` branch) and shows under the line
          // at checkout, where Skio's $0 children do not exist yet.
          if (bundleParts.length > 0) {
            parentProperties.Bundle = bundleParts.join(', ');
          }
          if (hasFgMixed && staticBoxSellingPlanId > 0) {
            parentProperties._free_gift_parent = 'true';
            parentProperties._free_gift_group_id = boxGroupId;
            parentProperties._free_gift_parent_variant_id = String(
              staticBoxVariantId
            );
            parentProperties._is_free_gift = 'false';
          }

          var fgMixedItems = hasFgMixed
            ? fgMixed
                .map(function (gift) {
                  var gv = rdlNormalizeVariantId(gift.variantId);
                  if (
                    !gv ||
                    gift.autoAddDisabled === true ||
                    gift.autoAddDisabled === 'true'
                  ) {
                    return null;
                  }
                  return {
                    id: gv,
                    quantity: 1,
                    parent_id: staticBoxVariantId,
                    properties: {
                      _is_free_gift: 'true',
                      __free_gift: true,
                      _free_gift_child: 'true',
                      _free_gift_group_id: boxGroupId,
                      _free_gift_parent_variant_id: String(staticBoxVariantId),
                    },
                  };
                })
                .filter(Boolean)
            : [];

          if (fgMixedItems.length > 0) {
            parentProperties.__free_gift_items = fgMixedItems
              .map(function (item) {
                return String(item.id);
              })
              .join(',');
          }

          var parentLine = {
            id: staticBoxVariantId,
            quantity: 1,
            properties: parentProperties,
          };
          if (staticBoxSellingPlanId > 0) {
            parentLine.selling_plan = staticBoxSellingPlanId;
          }

          rdlDoCartAdd(
            [parentLine].concat(fgMixedItems),
            button,
            errorEl
          );
        }).catch(function (err) {
          console.error('rdl-hero ATC:', err);
          if (errorEl) {
            errorEl.textContent =
              err.message || 'Sorry, something went wrong. Please try again.';
            errorEl.removeAttribute('hidden');
          }
          if (button) {
            button.disabled = false;
            button.classList.remove('is-loading');
          }
        });
        return;
      }
      // Same-flavour × 3 matching server-rendered flavour: fall through to normal path
    }
    // ── End build-mode branch ─────────────────────────────────────────

    var variantId = idInput ? parseInt(idInput.value, 10) : 0;
    var sellingPlanId = spInput && spInput.value ? parseInt(spInput.value, 10) : 0;
    if (!variantId) return;

    var items;
    if (sellingPlanId > 0) {
      var freeGifts = window.ThatWorks && window.ThatWorks.freeGiftsWithSubscriptionOfVariants
        ? window.ThatWorks.freeGiftsWithSubscriptionOfVariants[variantId]
        : null;
      var hasFreeGifts = Array.isArray(freeGifts) && freeGifts.length > 0;
      var freeGiftGroupId = Date.now() + '-' + Math.random().toString(16).slice(2);

      var parentProperties = {};
      if (hasFreeGifts) {
        parentProperties._free_gift_parent = 'true';
        parentProperties._free_gift_group_id = freeGiftGroupId;
        parentProperties._free_gift_parent_variant_id = String(variantId);
        parentProperties._is_free_gift = 'false';
      }

      var freeGiftItems = hasFreeGifts
        ? freeGifts.map(function (gift) {
            var giftVariantId = rdlNormalizeVariantId(gift.variantId);
            if (!giftVariantId || gift.autoAddDisabled === true || gift.autoAddDisabled === 'true') return null;
            return {
              id: giftVariantId,
              quantity: 1,
              properties: {
                _is_free_gift: 'true',
                __free_gift: true,
                _free_gift_child: 'true',
                _free_gift_group_id: freeGiftGroupId,
                _free_gift_parent_variant_id: String(variantId)
              }
            };
          }).filter(function (item) { return item !== null; })
        : [];

      if (freeGiftItems.length > 0) {
        parentProperties.__free_gift_items = freeGiftItems
          .map(function (item) { return String(item.id); })
          .join(',');
      }

      var parentLine = {
        id: variantId,
        quantity: 1,
        selling_plan: sellingPlanId,
        properties: parentProperties
      };

      items = rdlBuildParentWithGiftLines(parentLine, freeGiftItems);
    } else {
      items = [{ id: variantId, quantity: 1 }];
    }

    rdlDoCartAdd(items, button, errorEl);
  });

  // "Ready to ship — arrives by..." date — computed client-side so it reflects
  // the viewer's actual current date (Liquid's `now` is fixed at render/cache
  // time). Mirrors the addBusinessDays/locale logic used by .pp_atc_meta_line
  // in snippets/old-cta-part.liquid. Idempotent, can be re-run after swap.
  window.rdlSetShipDate = function () {
    var els = document.querySelectorAll('[data-rdl-ship-date]');
    if (!els.length) return;

    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    function addBusinessDays(startDate, numDays) {
      var newDate = new Date(startDate);
      var businessDays = 0;
      while (businessDays < numDays) {
        newDate.setDate(newDate.getDate() + 1);
        if (newDate.getDay() !== 0) businessDays++;
      }
      return newDate;
    }

    function ordinalSuffix(day) {
      var mod100 = day % 100;
      if (mod100 >= 11 && mod100 <= 13) return 'th';
      switch (day % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    }

    var currentUrl = String(window.location.href);
    var businessDayCount = (currentUrl.indexOf('en-eu') !== -1 || currentUrl.indexOf('en-us') !== -1) ? 5 : 2;
    var shipDate = addBusinessDays(new Date(), businessDayCount);
    var day = shipDate.getDate();
    var formatted = months[shipDate.getMonth()] + ' ' + day + ordinalSuffix(day);

    els.forEach(function (el) { el.textContent = formatted; });
  };
  window.rdlSetShipDate();

  // IntersectionObserver init for the sold bar — idempotent, can be re-run after swap.
  window.rdlObserveSold = function () {
    var cards = document.querySelectorAll('[data-rdl-sold]:not(.rdl-observed)');
    if (!cards.length) return;
    if (typeof IntersectionObserver === 'undefined') {
      cards.forEach(function (c) { c.classList.add('is-visible'); c.classList.add('rdl-observed'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) entry.target.classList.add('is-visible');
        else entry.target.classList.remove('is-visible');
      });
    }, { threshold: 0.4 });
    cards.forEach(function (c) {
      c.classList.add('rdl-observed');
      io.observe(c);
    });
  };
  window.rdlObserveSold();

  // Format / Flavour click → AJAX-swap the hero section instead of a full page reload.
  document.addEventListener('click', function (e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
    var link = e.target.closest('.rdl-flavour, .rdl-format');
    if (!link) return;
    var section = link.closest('[data-rdl-section]');
    if (!section) return;
    // link.href is absolute. With a product override the links point to the
    // product's own PDP (a different path than the current page); on a real PDP
    // they point back to the current page.
    var url;
    try { url = new URL(link.href); } catch (err) { return; }
    var variantId = url.searchParams.get('variant');
    if (!variantId) return;

    // Cross-path = the section is placed on a non-product page via product_override,
    // so its links target the product's PDP. The Section Rendering API on the
    // current (non-product) page has no product context, so ?variant would be
    // ignored — instead fetch the product's PDP as a full page (where ?variant
    // resolves server-side) and extract this section from the response.
    var crossPath = url.pathname !== window.location.pathname;
    var sectionId = section.getAttribute('data-section-id');
    if (!crossPath && !sectionId) return;

    e.preventDefault();
    section.classList.add('rdl-loading');

    // Keep the currently selected bundle (1x / 3x) across flavour/format swaps.
    var selectedBundle = section.querySelector('.rdl-bundle__input:checked');
    var retainedBundleValue = selectedBundle ? selectedBundle.value : '1x';

    var fetchUrl;
    if (crossPath) {
      // Keep the visible URL on the current page; only reflect the chosen variant.
      var displayParams = new URLSearchParams(window.location.search);
      displayParams.set('variant', variantId);
      history.pushState({}, '', window.location.pathname + '?' + displayParams.toString());
      // Fetch the product PDP (link target) with its view + variant params.
      fetchUrl = url.pathname + url.search;
    } else {
      // Same-path (rendered on the product's own PDP): use the lighter Section
      // Rendering API. Preserve existing query params; only change `variant`.
      var newParams = new URLSearchParams(window.location.search);
      newParams.set('variant', variantId);
      history.pushState({}, '', url.pathname + '?' + newParams.toString());
      var apiParams = new URLSearchParams(newParams);
      apiParams.set('section_id', sectionId);
      fetchUrl = url.pathname + '?' + apiParams.toString();
    }

    fetch(fetchUrl, { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error('Section fetch ' + r.status); return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html.trim();
        var newSection = tmp.querySelector('[data-rdl-section]');
        // Guard: if the fetched section is missing key elements, treat as failure.
        if (!newSection || !newSection.querySelector('.rdl-flavours') || !newSection.querySelector('.rdl-bundles')) {
          throw new Error('Section response missing expected elements');
        }

        // Apply retained bundle before paint so 1x never flashes first.
        rdlApplyBundleSelection(newSection, retainedBundleValue);

        section.replaceWith(newSection);

        window.rdlObserveSold();
        window.rdlSetShipDate();
        // Section swap inserts new gallery markup but does not re-run snippet
        // scripts — re-wire desktop thumb arrows on the new slider.
        if (typeof window.initLympPdpGallery === 'function') {
          window.initLympPdpGallery();
        } else {
          document.dispatchEvent(new CustomEvent('lymp:gallery-refreshed'));
        }
      })
      .catch(function (err) {
        console.warn('rdl-hero swap fell back to navigation:', err);
        window.location.href = link.href;
      });
  });

  // ============================================================
  //  BUILD-YOUR-BUNDLE  (A/B/C test — Variants B and C only)
  //
  //  Intelligems activates via HTML class on <html>:
  //    ab-ig-rdl-bundle-b  →  Variant B (current flavour × 3 default)
  //    ab-ig-rdl-bundle-c  →  Variant C (3 best-sellers × 1 each default)
  //
  //  QA escape hatch: append ?rdl_bundle=b or ?rdl_bundle=c to the URL.
  // ============================================================

  var rdlStaticBoxCache = null;
  var rdlStaticBoxPromise = null;

  /**
   * Fetch and cache Skio Static Box selectable variants.
   * @returns {Promise<Array>}
   */
  function rdlEnsureStaticBox() {
    if (rdlStaticBoxCache) {
      return Promise.resolve(rdlStaticBoxCache);
    }
    if (rdlStaticBoxPromise) {
      return rdlStaticBoxPromise;
    }

    var config = window.rdlBundleConfig || {};
    var variantId = String(config.staticBoxVariantId || '').trim();
    var sellingPlanId = String(config.staticBoxSellingPlanId || '').trim();
    if (!variantId) {
      return Promise.reject(new Error('Static box is not configured.'));
    }

    var body = { productVariantPlatformId: variantId };
    if (sellingPlanId) {
      body.sellingPlanPlatformId = sellingPlanId;
    }

    rdlStaticBoxPromise = fetch(
      'https://api.skio.com/storefront-http/get-classic-box-v2',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      }
    )
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (!data || !data.ok || !data.ClassicBoxV2) {
          throw new Error('Failed to load mixed bundle options.');
        }
        rdlStaticBoxCache = data.ClassicBoxV2.selectableProductVariants || [];
        rdlStaticBoxPromise = null;
        return rdlStaticBoxCache;
      })
      .catch(function (err) {
        rdlStaticBoxPromise = null;
        throw err;
      });

    return rdlStaticBoxPromise;
  }

  /**
   * Map a flavour display name to the Static Box selectable variant ID.
   * @param {string} flavourName
   * @returns {number}
   */
  function rdlFindBoxVariantId(flavourName) {
    if (!flavourName || !rdlStaticBoxCache) return 0;
    var target = String(flavourName).trim().toLowerCase();
    var match = rdlStaticBoxCache.find(function (variant) {
      var title = (variant.productVariantTitle || '')
        .split(' / ')[0]
        .trim()
        .toLowerCase();
      return title === target;
    });
    if (!match || !match.platformId) return 0;
    return parseInt(String(match.platformId).split('/').pop(), 10) || 0;
  }

  /**
   * Dim / disable build tiles whose flavour is not in the Static Box.
   * @param {Element} section
   */
  function rdlMarkBoxEligibility(section) {
    if (!section || !rdlStaticBoxCache) return;

    var names = {};
    rdlStaticBoxCache.forEach(function (variant) {
      var title = (variant.productVariantTitle || '')
        .split(' / ')[0]
        .trim()
        .toLowerCase();
      if (title) names[title] = true;
    });

    section.querySelectorAll('[data-rdl-build-tile]').forEach(function (tile) {
      var flavourName = (tile.getAttribute('data-flavour-name') || '')
        .trim()
        .toLowerCase();
      var available = !!names[flavourName];
      tile.classList.toggle('rdl-build-tile--unavailable', !available);
    });

    if (section.classList.contains('rdl-bundle-mode')) {
      rdlRenderBuildUI(section);
    }
  }

  /**
   * Returns the active test variant: 'b', 'c', or 'control'.
   * URL param takes priority over HTML class (for QA without Intelligems).
   */
  function rdlBundleVariant() {
    var urlParam = new URLSearchParams(window.location.search).get('rdl_bundle');
    if (urlParam === 'b' || urlParam === 'c') return urlParam;
    var cl = document.documentElement.classList;
    if (cl.contains('ab-ig-rdl-bundle-b')) return 'b';
    if (cl.contains('ab-ig-rdl-bundle-c')) return 'c';
    return 'control';
  }

  /**
   * Returns true when build mode should be active for a section:
   * variant is B or C, and the 3x bundle radio is checked.
   * @param {Element} section
   */
  function rdlIsBuildMode(section) {
    if (rdlBundleVariant() === 'control') return false;
    var checked = section.querySelector('.rdl-bundle__input:checked');
    return !!(checked && checked.value === '3x');
  }

  // Per-section allocation state: flavourHandle → quantity (integer)
  var rdlBundleState = {};

  /** Sum of all allocated quantities. */
  function rdlBundleTotal() {
    return Object.keys(rdlBundleState).reduce(function (sum, k) {
      return sum + (rdlBundleState[k] || 0);
    }, 0);
  }

  /**
   * Sync all tile visuals and the counter/ATC button from rdlBundleState.
   * @param {Element} section
   */
  function rdlRenderBuildUI(section) {
    var total = rdlBundleTotal();
    var maxReached = total >= 3;
    var hasUnavailableQty = false;
    section.querySelectorAll(
      '[data-rdl-build-tile].rdl-build-tile--unavailable'
    ).forEach(function (tile) {
      var fl = tile.getAttribute('data-flavour');
      if ((rdlBundleState[fl] || 0) > 0) hasUnavailableQty = true;
    });

    section.querySelectorAll('[data-rdl-build-tile]').forEach(function (tile) {
      var fl = tile.getAttribute('data-flavour');
      var qty = rdlBundleState[fl] || 0;
      var qtyEl = tile.querySelector('[data-rdl-tile-qty]');
      var minusBtn = tile.querySelector('[data-rdl-bundle-minus]');
      var plusBtn = tile.querySelector('[data-rdl-bundle-plus]');
      var unavailable = tile.classList.contains('rdl-build-tile--unavailable');

      tile.classList.toggle('is-active', qty > 0);

      if (qtyEl) {
        qtyEl.textContent = qty;
        qtyEl.style.display = qty > 0 ? '' : 'none';
      }
      if (minusBtn) {
        minusBtn.style.display = qty > 0 ? '' : 'none';
        minusBtn.disabled = qty <= 0;
      }
      if (plusBtn) {
        plusBtn.disabled = maxReached || unavailable ||
          (hasUnavailableQty && !unavailable);
      }
    });

    var counter = section.querySelector('[data-rdl-build-counter]');
    if (counter) {
      var counterText = counter.querySelector('[data-rdl-build-counter-text]');
      if (total >= 3) {
        if (counterText) counterText.textContent = '3/3 Selected';
        counter.classList.add('is-complete');
      } else {
        if (counterText) counterText.textContent = total + '/3 Selected';
        counter.classList.remove('is-complete');
      }
    }

    var atcBtn = section.querySelector('.rdl-atc');
    if (atcBtn) {
      atcBtn.disabled = total !== 3;
      atcBtn.classList.toggle('rdl-atc--incomplete', total !== 3);
    }
  }

  /**
   * Write an allocation map into rdlBundleState and re-render all tiles.
   * @param {Element} section
   * @param {Object}  alloc  - { flavourHandle: quantity }
   */
  function rdlApplyAllocation(section, alloc) {
    rdlBundleState = {};
    section.querySelectorAll('[data-rdl-build-tile]').forEach(function (tile) {
      var fl = tile.getAttribute('data-flavour');
      rdlBundleState[fl] = alloc[fl] || 0;
    });
    rdlRenderBuildUI(section);
  }

  /**
   * Build the default allocation for Variant B: current flavour × 3.
   * Falls back to the first tile when the selected flavour is not found.
   * @param {Element} section
   * @returns {Object}
   */
  function rdlDefaultBuildB(section) {
    var alloc = {};
    section.querySelectorAll('[data-rdl-build-tile]').forEach(function (tile) {
      alloc[tile.getAttribute('data-flavour')] = 0;
    });
    var selected = section.querySelector('.rdl-flavour.is-selected');
    var currentFl = selected ? selected.getAttribute('data-flavour') : null;
    if (currentFl && Object.prototype.hasOwnProperty.call(alloc, currentFl)) {
      alloc[currentFl] = 3;
    } else {
      var first = Object.keys(alloc)[0];
      if (first) alloc[first] = 3;
    }
    return alloc;
  }

  /**
   * Build the default allocation for Variant C: 3 best-sellers × 1 each.
   * Best-sellers come from window.rdlBundleConfig.variantCFlavours (section setting).
   * Falls back to the first unmatched tiles if fewer than 3 best-sellers are found.
   * @param {Element} section
   * @returns {Object}
   */
  function rdlDefaultBuildC(section) {
    var alloc = {};
    section.querySelectorAll('[data-rdl-build-tile]').forEach(function (tile) {
      alloc[tile.getAttribute('data-flavour')] = 0;
    });
    var config = window.rdlBundleConfig || {};
    var bestsellers = Array.isArray(config.variantCFlavours) ? config.variantCFlavours : [];
    var assigned = 0;

    bestsellers.forEach(function (rawName) {
      if (assigned >= 3) return;
      var name = rawName.trim();
      section.querySelectorAll('[data-rdl-build-tile]').forEach(function (tile) {
        if (assigned >= 3) return;
        var tileName = (tile.getAttribute('data-flavour-name') || '').trim();
        var tileHandle = tile.getAttribute('data-flavour');
        if (
          tileName.toLowerCase() === name.toLowerCase() ||
          tileHandle === name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '')
        ) {
          if (!alloc[tileHandle]) {
            alloc[tileHandle] = 1;
            assigned++;
          }
        }
      });
    });

    // Pad with first unallocated tiles if fewer than 3 best-sellers matched
    if (assigned < 3) {
      section.querySelectorAll('[data-rdl-build-tile]').forEach(function (tile) {
        if (assigned >= 3) return;
        var fl = tile.getAttribute('data-flavour');
        if (!alloc[fl]) {
          alloc[fl] = 1;
          assigned++;
        }
      });
    }
    return alloc;
  }

  /**
   * Enter build mode: add class, show build UI, apply defaults.
   * @param {Element} section
   */
  function rdlEnterBuildMode(section) {
    var variant = rdlBundleVariant();
    var alloc = variant === 'c' ? rdlDefaultBuildC(section) : rdlDefaultBuildB(section);
    section.classList.add('rdl-bundle-mode');
    var buildEl = section.querySelector('.rdl-flavours__build');
    if (buildEl) buildEl.removeAttribute('aria-hidden');
    rdlApplyAllocation(section, alloc);
    rdlEnsureStaticBox().then(function () {
      rdlMarkBoxEligibility(section);
    }).catch(function (err) {
      console.warn('[RDL Bundle] Static box load failed:', err);
    });
  }

  /**
   * Exit build mode: remove class, re-enable ATC, reset state.
   * @param {Element} section
   */
  function rdlExitBuildMode(section) {
    section.classList.remove('rdl-bundle-mode');
    var buildEl = section.querySelector('.rdl-flavours__build');
    if (buildEl) buildEl.setAttribute('aria-hidden', 'true');
    rdlBundleState = {};
    var atcBtn = section.querySelector('.rdl-atc');
    if (atcBtn) {
      atcBtn.disabled = false;
      atcBtn.classList.remove('rdl-atc--incomplete');
    }
  }

  // Bundle radio change: enter / exit build mode alongside the existing
  // rdlApplyBundleSelection call (both handlers fire; this runs second).
  document.addEventListener('change', function (e) {
    if (!e.target || e.target.name !== 'rdl-bundle' || !e.target.checked) return;
    if (rdlBundleVariant() === 'control') return;
    var section = e.target.closest('[data-rdl-section]');
    if (!section) return;
    if (e.target.value === '3x') {
      rdlEnterBuildMode(section);
    } else {
      rdlExitBuildMode(section);
    }
  });

  // Stepper +/- click handler (event-delegated, swap-safe)
  document.addEventListener('click', function (e) {
    var plusBtn = e.target.closest('[data-rdl-bundle-plus]');
    var minusBtn = e.target.closest('[data-rdl-bundle-minus]');
    if (!plusBtn && !minusBtn) return;
    e.preventDefault();
    e.stopPropagation();
    var section = (plusBtn || minusBtn).closest('[data-rdl-section]');
    if (!section) return;
    var tile = (plusBtn || minusBtn).closest('[data-rdl-build-tile]');
    if (!tile) return;
    var fl = tile.getAttribute('data-flavour');
    var current = rdlBundleState[fl] || 0;
    var total = rdlBundleTotal();
    if (plusBtn && !plusBtn.disabled && total < 3) {
      rdlBundleState[fl] = current + 1;
    } else if (minusBtn && !minusBtn.disabled && current > 0) {
      rdlBundleState[fl] = current - 1;
    }
    rdlRenderBuildUI(section);
  });

  // On page load: if Intelligems has already set the activation class before
  // this script executes, check whether build mode should be active.
  (function rdlBundleInit() {
    if (rdlBundleVariant() === 'control') return;
    var section = document.querySelector('[data-rdl-section]');
    if (!section) return;
    rdlEnsureStaticBox().then(function () {
      rdlMarkBoxEligibility(section);
    }).catch(function (err) {
      console.warn('[RDL Bundle] Static box preload failed:', err);
    });
    var checked = section.querySelector('.rdl-bundle__input:checked');
    if (checked && checked.value === '3x') {
      rdlEnterBuildMode(section);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-lymphoria-how"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.rdh').forEach(function (sec) {
      var track = sec.querySelector('[data-rdh-track]');
      if (!track) return;
      var prev = sec.querySelector('[data-rdh-prev]');
      var next = sec.querySelector('[data-rdh-next]');
      var dotsWrap = sec.querySelector('[data-rdh-dots]');
      var cards = track.querySelectorAll('.rdh__card');
      if (!cards.length) return;
      function step() { var c = cards[0]; return c ? c.getBoundingClientRect().width + 12 : 320; }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        cards.forEach(function (c, i) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'rdh__dot';
          b.setAttribute('aria-label', 'Go to step ' + (i + 1));
          b.addEventListener('click', function () { track.scrollTo({ left: i * step(), behavior: 'smooth' }); });
          dotsWrap.appendChild(b);
        });
        var dots = dotsWrap.querySelectorAll('.rdh__dot');
        function sync() {
          var idx = Math.round(track.scrollLeft / step());
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        }
        sync();
        track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-lymphoria-ingredients"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.rdi').forEach(function (sec) {
      var track = sec.querySelector('[data-rdi-track]');
      if (!track) return;
      var prev = sec.querySelector('[data-rdi-prev]');
      var next = sec.querySelector('[data-rdi-next]');
      var dotsWrap = sec.querySelector('[data-rdi-dots]');
      var cards = track.querySelectorAll('.rdi__card');
      if (!cards.length) return;

      function step() { var c = cards[0]; return c ? c.getBoundingClientRect().width + 12 : 320; }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        cards.forEach(function (c, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'rdi__dot';
          b.setAttribute('aria-label', 'Go to ingredient ' + (i + 1));
          b.addEventListener('click', function () { track.scrollTo({ left: i * step(), behavior: 'smooth' }); });
          dotsWrap.appendChild(b);
        });
        var dots = dotsWrap.querySelectorAll('.rdi__dot');
        function sync() {
          var idx = Math.round(track.scrollLeft / step());
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        }
        sync();
        track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-lymphoria-journey"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var lists = document.querySelectorAll('[data-rdj-list]');
    if (!lists.length) return;

    function setupList(list) {
      var fill = list.querySelector('[data-rdj-fill]');
      var items = list.querySelectorAll('[data-rdj-item]');
      if (!fill || !items.length) return;

      function update() {
        var listRect = list.getBoundingClientRect();
        var triggerY = window.innerHeight * 0.7;
        var lastY = 0;

        items.forEach(function (item) {
          var marker = item.querySelector('.rdj__marker');
          if (!marker) return;
          var rect = marker.getBoundingClientRect();
          var centerY = rect.top + rect.height / 2;
          if (centerY <= triggerY) {
            item.classList.add('is-active');
            lastY = Math.max(lastY, rect.top + rect.height / 2 - listRect.top - 11);
          } else {
            item.classList.remove('is-active');
          }
        });

        fill.style.height = lastY + 'px';
      }

      window.addEventListener('scroll', function () {
        window.requestAnimationFrame(update);
      }, { passive: true });
      window.addEventListener('resize', update);
      update();
      // Re-run a few times after load to catch fonts/images shifting layout.
      setTimeout(update, 300);
      setTimeout(update, 1000);
    }

    lists.forEach(setupList);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-lymphoria-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.rdr');
    sections.forEach(function (sec) {
      var track = sec.querySelector('[data-rdr-track]');
      if (!track) return;
      var prevBtn = sec.querySelector('[data-rdr-prev]');
      var nextBtn = sec.querySelector('[data-rdr-next]');
      var dotsWrap = sec.querySelector('[data-rdr-dots]');
      var cards = track.querySelectorAll('.rdr__card');
      if (!cards.length) return;

      function step() {
        var card = cards[0];
        return card ? card.getBoundingClientRect().width + 12 : 320;
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (nextBtn) nextBtn.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

      // Dots
      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        cards.forEach(function (c, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'rdr__dot';
          b.setAttribute('aria-label', 'Go to review ' + (i + 1));
          b.addEventListener('click', function () {
            track.scrollTo({ left: i * step(), behavior: 'smooth' });
          });
          dotsWrap.appendChild(b);
        });
        var dots = dotsWrap.querySelectorAll('.rdr__dot');

        function syncDot() {
          var idx = Math.round(track.scrollLeft / step());
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        }
        syncDot();
        track.addEventListener('scroll', function () {
          window.requestAnimationFrame(syncDot);
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
